module.exports = __webpack_public_path__ + "static/media/bg_night.8bec163b.png";